import { render, staticRenderFns } from "./TicketThread.vue?vue&type=template&id=48a25a43"
import script from "./TicketThread.vue?vue&type=script&lang=ts"
export * from "./TicketThread.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports